export enum SortAuctionsTypesEnum {
    BrowseOptions,
    BrowseOptionsComingSoon,
    BrowseOptionsCompleted,
    BidWatchOptions,
    BidActiveOptions,
    BidWonOptions,
}
